import { graphql } from "@opensea/graphql"

export const CurrencySelector_relayerFulfillmentFragment = graphql(`
  fragment CurrencySelector_relayerFulfillment on RelayerFulfillment {
    crossChain
    sameChain
  }
`)
